Ext.define('SA.view.color.Slider', {
    alias: 'widget.color-window-slider',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-color-window-slider',
    maxValue: 255,

    initComponent() {
        var component = this.component,
            units = this.units;

        if (component === 'h') {
            this.maxValue = 359;
            units = '\u00B0';
        }
        else if (/s|l/.test(component)) {
            this.maxValue = 100;
            units = '%';
        }

        this.items = [
            {
                afterSubTpl: units ? '</td><td class="sa-color-window-slider-units-label">' + units : '',
                allowDecimals: false,
                fieldLabel: this.fieldLabel,
                labelSeparator: '',
                labelWidth: units ? 28 : 43,
                margin: units ? '5 15 5 0' : '5 0 5 0',
                maxLength: 3,
                maxValue: this.maxValue,
                minValue: 0,
                value: 255,
                width: units ? 75 : 90,
                xtype: 'sa-numberfield',

                listeners: {
                    blur(field) {
                        var maxValue = field.maxValue;

                        if (field.getValue() > maxValue) {
                            field.setValue(maxValue);
                        }
                    },

                    change: field => {
                        if (!field.settingValue && field.isValid()) {
                            var value = field.getValue();

                            if (/s|l/.test(component)) {
                                value /= 100;
                            }

                            this.fireEvent('change:color', this, this.color.derive(component, value));
                        }
                    }
                }
            }, {
                component,
                margin: '0 0 0 10',
                maxValue: this.maxValue,
                xtype: 'color-window-slide-bar',

                listeners: {
                    slide: (view, value) => {
                        this.field.setValue(value);
                    }
                }
            }
        ];

        this.refresh = SA.leadingEdgeBuffer(this.refresh, 100);

        this.callParent();

        this.field = this.down('sa-numberfield');
        this.slider = this.down('color-window-slide-bar');
    },

    refresh() {
        var component = this.component,
            field = this.field,
            color = this.color,
            value = color.get(component) || 0;

        this.slider.setColor(color);

        if (/s|l/.test(component)) {
            value *= 100;
        }

        if (value !== field.getValue()) {
            field.settingValue = true;
            field.setValue(value);
            field.settingValue = false;
        }
    },

    setColor(color) {
        this.color = color;

        this.refresh();
    }
});
